import { AxiosConfig } from '../../componentes/axiosConfig';

export class CriarExpedienteRastreavel {
    constructor() {
        this._axios = (new AxiosConfig()).instanciaAxios();

        this._formAddNovoExpediente   = 'form[name=form-add-horarios-expediente]';
        this._idformAddNovoExpediente = 'form-add-horarios-expediente';
        this._idContainerExpediente   = 'container-expediente-rastreavel';
        this._idBtnAddNovoExpediente  = 'btn-novo-expediente';
    }

    executar() {
        const containerExpediente= $(`#${this._idContainerExpediente}`);
        if (containerExpediente.length === 0) {
            return;
        }

        containerExpediente.on('click', `#${this._idBtnAddNovoExpediente}`, (evento) => {
            evento.preventDefault();
            this._criarVisao();
        });

        containerExpediente.on('submit', this._formAddNovoExpediente, (evento) => {
            evento.preventDefault();
            this._criarLogica();
        });
    }

    _criarVisao() {
        const urlAddNovoExpediente = document.getElementById(this._idBtnAddNovoExpediente);
        const containerExpediente  = document.getElementById(this._idContainerExpediente);

        this._axios.get(urlAddNovoExpediente.href)
        .then((response) => {
            containerExpediente.innerHTML = response.data;
        })
        .catch((error) => {
            console.log(error);
        });
    }

    _criarLogica() {
        const urlAddItemAlbum = document.querySelector(this._formAddNovoExpediente).action;
        const dadosFormulario = new FormData(document.getElementById(this._idformAddNovoExpediente));
        const containerAlbum  = document.getElementById(this._idContainerExpediente);

        console.log(dadosFormulario);
        console.log(dadosFormulario.values());
        this._axios.post(urlAddItemAlbum, dadosFormulario)
        .then((response) => {
            if (response) {
                containerAlbum.innerHTML = response.data;
            }
        })
        .catch((error) => {
            console.log(error);
        });
    }
}
